import { useCallback, useMemo, useState } from 'react'
import { formatMoney, ReplaceAllInstances } from '@itarget/shared'

const { toReal } = formatMoney

export const useCashbackWallet = ({
  balance = 0,
  totalToSpend = 0,
  balanceUsed = 0,
  cashbackSymbol = 'R$',
  translation,
  onApplyCashback,
  handleCleanAppliedCashbackWallet,
}) => {
  const [amountFromWallet, setAmountFromWallet] = useState('')
  const [utilizeWallet, setUtilizeWallet] = useState(true)

  const currentBalance = useMemo(
    () => Math.max(balance - balanceUsed, 0),
    [balance, balanceUsed],
  )

  const maxTotalToSpend = useMemo(
    () => Math.max(totalToSpend - balanceUsed, 0),
    [totalToSpend, balanceUsed],
  )

  const maxInsertToSpend = useMemo(
    () => Math.min(currentBalance, maxTotalToSpend),
    [currentBalance, maxTotalToSpend],
  )

  const formattedBalance = useMemo(
    () => toReal(currentBalance),
    [currentBalance],
  )

  const formattedRedemptionLimit = useMemo(
    () => toReal(maxInsertToSpend),
    [maxInsertToSpend],
  )

  const redemptionLimitTranslation = balanceUsed
    ? translation.redemptionLimitValueWithUsed
    : translation.redemptionLimitValue

  const redemptionLimitText = useMemo(
    () =>
      ReplaceAllInstances(redemptionLimitTranslation, [
        `${cashbackSymbol} ${formattedRedemptionLimit}`,
      ]),
    [cashbackSymbol, formattedRedemptionLimit, redemptionLimitTranslation],
  )

  const handleChangeAmountFromWallet = useCallback((value) => {
    setAmountFromWallet(value)
  }, [])

  const handleChangeCheckboxUtilizeWallet = useCallback(
    (changeEvent) => {
      if (handleCleanAppliedCashbackWallet) {
        handleCleanAppliedCashbackWallet()
      }
      const checked = changeEvent.target.checked
      setUtilizeWallet(checked)

      if (!checked) {
        setAmountFromWallet('')
      }
    },
    [handleCleanAppliedCashbackWallet],
  )

  const handleApplyCashback = useCallback(() => {
    if (!amountFromWallet || !onApplyCashback) return

    onApplyCashback(amountFromWallet)
    setAmountFromWallet('')
  }, [amountFromWallet, onApplyCashback])

  return {
    utilizeWallet,
    amountFromWallet,

    formattedBalance,
    redemptionLimitText,
    maxInsertToSpend,
    cashbackSymbol,

    handleChangeAmountFromWallet,
    handleChangeCheckboxUtilizeWallet,
    handleApplyCashback,
  }
}
